<template>
  <div>
    <div data-cy="form-label" class="b-dialog__top-panel mb-4">
      <h2>{{$t('CONTENT.contract.contract_editing')}}</h2>
      <button class="b-btn b-btn_border_none" @click="closeContractEditingDialog">
        <dynamic-icon icon="close" />
      </button>
    </div>
    <form class="b-form b-dialog__form">
      <server-error :error="error" />
      <div class="row px-0">
        <div class="col-12">
          <label for="responsible">{{$t('CONTENT.contract.initiator')}}:<span class="b-form__required"> </span></label>
          <input
            data-cy="contract-number"
            type="text"
            id="responsible"
            class="b-input"
            name="responsible"
            required
            v-model.lazy="formData.responsible"
          />
        </div>
        <div class="col-12">
          <label for="responsible">{{$t('CONTENT.comment')}}:<span class="b-form__required"> </span></label>
          <input
            data-cy="contract-number"
            type="text"
            id="responsible"
            class="b-input"
            name="responsible"
            required
            v-model.lazy="formData.commentary"
          />
        </div>
        <div class="col-12">
          <label for="responsible">{{$t('CONTENT.contract.prolongation_type')}}:<span class="b-form__required"> </span></label>
          <input
            data-cy="contract-number"
            type="text"
            id="responsible"
            class="b-input"
            name="responsible"
            required
            v-model.lazy="formData.prolongationType"
          />
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-6 offset-6">
          <div
            class="b-form__container b-form__container_type_flex b-form__container_type_flex_end"
          >
            <button
              data-cy="save-button"
              class="b-btn b-btn_type_primary"
              type="submit"
              @click="onSubmit"
            >{{$t('CONTENT.save')}}</button>
            <button
              class="b-btn b-btn_type_empty m-2"
              @click.prevent="closeContractEditingDialog"
            >{{$t('CONTENT.cancel')}}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GeneralForm from "../../../../directories/counterparty/edit/GeneralForm";
import ImportDialogWidget from "../../../../widgets/ImportDialogWidget";
import dateConverter from "../../../../../utils/converters/date.converter";
import LessorItemEdit from "./LessorItemEdit";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';

export default {
  components: {
    LessorItemEdit,
    GeneralForm,
    ImportDialogWidget
  },
  mixins: [datepickerFormat],
  props: {
    contract: {
      type: Object
    },
  },
  data() {
    return {
      error: null,
      counter: 0,
      isContractEditingShow: false,
      isDisabledAddLessor: false,
      validationErrors: [],
      formData: {},
    };
  },
  created() {
    this.updateFormData();
  },
  watch: {
    contract: {
      immediate: true,
      handler() {
        this.updateFormData();
      }
    },
  },
  computed: {
    ...mapGetters(["getCounterpartiresForContract"]),
    ...mapGetters(["allCounterparties"]),
    date: {
      get() {
        if (this.formData.date === null) {
          return null;
        } else {
          return dateConverter.convertToDate(this.formData.date);
        }
      },
      set(newVal) {
        if(newVal !== null) {
          this.formData.date = dateConverter.convertToString(newVal);
        } else {
          this.formData.date = null;
        }
      }
    },
    counterparties() {
      return this.getCounterpartiresForContract;
    },
    currentLessee: {
      get() {
        return this.formData.lesseeCounterpartyId;
      },
      set(newVal) {
        this.formData.lesseeCounterpartyId = +newVal;
      }
    },
  },
  methods: {
    updateFormData() {
      if (this.contract != null) {
        this.formData = _.cloneDeep (this.contract);
      }
    },
    addLessor() {
      this.formData.lessorCounterpartyIds.push(null);
      this.isDisabledAddLessor = true;
    },
    onSelectLessor(data) {
      this.formData.lessorCounterpartyIds[data.index] = data.value;
      this.isDisabledAddLessor = false;
    },
    closeContractEditingDialog() {
      this.$emit("close");
      this.formData = _.cloneDeep(this.contract);
    },
    deleteLessorItem(index) {
      this.formData.lessorCounterpartyIds.splice(index, 1);
      this.isDisabledAddLessor = false;
      this.counter++;
    },
    onSubmit(e) {
      e.preventDefault();
      // if (!this.validate()) return;
      this.$emit('onSaveEditing', this.formData);
      this.$emit("close");
      this.formData = _.cloneDeep(this.contract);
    },
    checkIsCounterpartyIntragroup(counterpartyId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if (this.allCounterparties[i].idInDB === counterpartyId) {
          return this.allCounterparties[i].isIntragroupTurnover;
        }
      }
    },
    validate() {
      this.validationErrors = [];
      if (!this.formData.number) {
        this.validationErrors.push('number');
      }
      if (!this.formData.lesseeCounterpartyId) {
        this.validationErrors.push('currentLessee');
      }
      if (!this.formData.date) {
        this.validationErrors.push('date');
      }
      if (!this.arrayIsNotEmpty(this.formData.lessorCounterpartyIds)) {
        this.validationErrors.push('lessor');
      }
      return this.validationErrors.length <= 0;
    },
    isFieldWithError(field, value) {
      return !value && this.validationErrors && this.validationErrors.includes(field);
    },
    arrayIsNotEmpty(array) {
      return Array.isArray(array) && array.length > 0 && array.every(a => !!a);
    }
  }
};
</script>
